module.exports = __webpack_public_path__ + "5a56b7b8e561c331fded99bada72d2b2.pdf";